export const ENC = {
  page: "encounters-page",
  title: "encounters-title",
  newBtn: "new-encounter-btn",
  patientFilter: "encounter-patient-filter",
  table: "encounters-table",
  emptyState: "encounters-empty",
  loading: "encounters-loading",
  row: "enc-row",
  viewFhirBtn: "enc-view-fhir-btn",
  editBtn: "enc-edit-btn",
  deleteBtn: "enc-delete-btn",
  form: "encounter-form",
  fPatient: "enc-field-patient",
  fLocation: "enc-field-location",
  fStatus: "enc-field-status",
  fClass: "enc-field-class",
  fType: "enc-field-type",
  fStart: "enc-field-start",
  fEnd: "enc-field-end",
  saveBtn: "encounter-save-btn",
  cancelBtn: "encounter-cancel-btn",
  deleteDialog: "delete-encounter-dialog",
  confirmDelete: "confirm-delete-encounter-btn",
  navEncounters: "nav-encounters",
  openBtn: "enc-open-btn",
  screen: "encounter-screen",
  screenBack: "encounter-screen-back",
  screenTabs: "encounter-screen-tabs",
  screenTab: "encounter-screen-tab",
  screenWorkspace: "encounter-screen-workspace",
  screenPatientColumn: "encounter-screen-patient-column",
  screenPaneNotes: "encounter-screen-pane-notes",
  screenChartDivider: "encounter-screen-chart-divider",
  screenChartCollapse: "encounter-screen-chart-collapse",
  screenChartExpand: "encounter-screen-chart-expand",
  screenChartTabs: "encounter-screen-chart-tabs",
  screenChartTab: "encounter-screen-chart-tab",
  screenChartPanel: "encounter-screen-chart-panel",
  screenIdentityBar: "encounter-screen-identity-bar",
  screenIdentityName: "encounter-screen-identity-name",
  screenIdentityMrn: "encounter-screen-identity-mrn",
  screenIdentityDob: "encounter-screen-identity-dob",
  screenNotes: "encounter-screen-notes",
  screenNotesEmpty: "encounter-screen-notes-empty",
  screenNoteTypes: "encounter-screen-note-types",
  screenNoteType: "encounter-screen-note-type",
  screenNewVisitNote: "encounter-screen-new-visit-note",
  screenNewNote: "encounter-screen-new-note",
  screenNoteList: "encounter-screen-note-list",
  screenNoteRow: "encounter-screen-note-row",
  screenNoteTabs: "encounter-screen-note-tabs",
  screenNoteTabNote: "encounter-screen-note-tab-note",
  screenNoteTabList: "encounter-screen-note-tab-list",
  screenNoteTabPanelNote: "encounter-screen-note-tab-panel-note",
  screenNoteTabPanelList: "encounter-screen-note-tab-panel-list",
  screenCurrentNote: "encounter-screen-current-note",
  screenNoteStatus: "encounter-screen-note-status",
  screenNoteSave: "encounter-screen-note-save",
  screenNoteSign: "encounter-screen-note-sign",
  screenNoteAddendum: "encounter-screen-note-addendum",
  screenNoteCorrection: "encounter-screen-note-correction",
  screenNotePrint: "encounter-screen-note-print",
  screenNotePrintDocument: "encounter-screen-note-print-document",
  screenNotePrintFirstPage: "encounter-screen-note-print-first-page",
  screenNotePrintSubsequentPage: "encounter-screen-note-print-subsequent-page",
  screenNoteHistory: "encounter-screen-note-history",
  screenNoteHistoryDialog: "encounter-screen-note-history-dialog",
  screenNoteHistoryRow: "encounter-screen-note-history-row",
  screenNoteEditor: "encounter-screen-note-editor",
  screenNoteDiagnoses: "encounter-screen-note-diagnoses",
  screenNoteCptReserved: "encounter-screen-note-cpt-reserved",
  screenCptWorkspace: "encounter-screen-cpt-workspace",
  screenCptSearch: "encounter-screen-cpt-search",
  screenCptSearchInput: "encounter-screen-cpt-search-input",
  screenCptResults: "encounter-screen-cpt-results",
  screenCptResult: "encounter-screen-cpt-result",
  screenCptSearchLoading: "encounter-screen-cpt-search-loading",
  screenCptSearchEmpty: "encounter-screen-cpt-search-empty",
  screenCptSearchError: "encounter-screen-cpt-search-error",
  screenSelectedCpt: "encounter-screen-selected-cpt",
  screenSelectedCptRow: "encounter-screen-selected-cpt-row",
  screenCptRemove: "encounter-screen-cpt-remove",
  screenNewNoteDialog: "encounter-screen-new-note-dialog",
  screenNewNoteType: "encounter-screen-new-note-type",
  screenNewNoteTitle: "encounter-screen-new-note-title",
  screenNewNoteCreate: "encounter-screen-new-note-create",
  screenSoapEditor: "encounter-screen-soap-editor",
  screenNoteRtfToolbar: "encounter-screen-note-rtf-toolbar",
  screenNoteRtfBold: "encounter-screen-note-rtf-bold",
  screenNoteRtfItalic: "encounter-screen-note-rtf-italic",
  screenNoteRtfUnderline: "encounter-screen-note-rtf-underline",
  screenNoteRtfBullet: "encounter-screen-note-rtf-bullet",
  screenNoteRtfNumber: "encounter-screen-note-rtf-number",
  screenNoteRtfAlignLeft: "encounter-screen-note-rtf-align-left",
  screenNoteRtfAlignCenter: "encounter-screen-note-rtf-align-center",
  screenNoteRtfAlignRight: "encounter-screen-note-rtf-align-right",
  screenNoteRtfUndo: "encounter-screen-note-rtf-undo",
  screenNoteRtfRedo: "encounter-screen-note-rtf-redo",
  screenInsertField: "encounter-screen-insert-field",
  screenInsertSmartPhrase: "encounter-screen-insert-smartphrase",
  screenWhatToOrder: "encounter-screen-what-to-order",
  screenOrders: "encounter-screen-orders",
  screenDiagnosis: "encounter-screen-diagnosis",
  screenDiagnosisSearch: "encounter-screen-diagnosis-search",
  screenDiagnosisSearchInput: "encounter-screen-diagnosis-search-input",
  screenDiagnosisResults: "encounter-screen-diagnosis-results",
  screenDiagnosisResult: "encounter-screen-diagnosis-result",
  screenDiagnosisSearchLoading: "encounter-screen-diagnosis-search-loading",
  screenDiagnosisSearchEmpty: "encounter-screen-diagnosis-search-empty",
  screenDiagnosisSearchError: "encounter-screen-diagnosis-search-error",
  screenEncounterDiagnoses: "encounter-screen-encounter-diagnoses",
  screenEncounterDiagnosisRow: "encounter-screen-encounter-diagnosis-row",
  screenDiagnosisWorkspace: "encounter-screen-diagnosis-workspace",
  screenDiagnosisSourceTabs: "encounter-screen-diagnosis-source-tabs",
  screenDiagnosisSourceTab: "encounter-screen-diagnosis-source-tab",
  screenDiagnosisCommon: "encounter-screen-diagnosis-common",
  screenDiagnosisPrior: "encounter-screen-diagnosis-prior",
  screenDiagnosisProblemList: "encounter-screen-diagnosis-problem-list",
  screenDiagnosisMoveUp: "encounter-screen-diagnosis-move-up",
  screenDiagnosisMoveDown: "encounter-screen-diagnosis-move-down",
  screenDiagnosisMakePrimary: "encounter-screen-diagnosis-make-primary",
  screenDiagnosisRemove: "encounter-screen-diagnosis-remove",
  screenDiagnosisRemoveAll: "encounter-screen-diagnosis-remove-all",
  screenDiagnosisClearPrimary: "encounter-screen-diagnosis-clear-primary",
  screenOrdersWorkspace: "encounter-screen-orders-workspace",
  screenCpt: "encounter-screen-cpt",
  screenSign: "encounter-screen-sign",
  screenSignDialog: "encounter-screen-sign-dialog",
  screenConfirmSign: "encounter-screen-confirm-sign",
  screenPrint: "encounter-screen-print",
  screenMore: "encounter-screen-more",
  screenClose: "encounter-screen-close",
  screenCloseDialog: "encounter-screen-close-dialog",
  screenConfirmClose: "encounter-screen-confirm-close",
  screenReopen: "encounter-screen-reopen",
  screenReopenDialog: "encounter-screen-reopen-dialog",
  screenConfirmReopen: "encounter-screen-confirm-reopen",
  screenLifecycle: "encounter-screen-lifecycle",

  // Right-side collapsible Diagnosis / CPT Code / Order panel.
  screenCodingColumn: "encounter-screen-coding-column",
  screenCodingCollapse: "encounter-screen-coding-collapse",
  screenCodingExpand: "encounter-screen-coding-expand",
  screenCodingPanel: "encounter-screen-coding-panel",
  screenCodingTabs: "encounter-screen-coding-tabs",
  screenCodingTab: "encounter-screen-coding-tab",
  screenCodingEmpty: "encounter-screen-coding-empty",
  screenOrderPanel: "encounter-screen-order-panel",
  screenOrderSearchInput: "encounter-screen-order-search-input",
  screenOrderCategories: "encounter-screen-order-categories",
  screenOrderCategory: "encounter-screen-order-category",
  screenOrderResults: "encounter-screen-order-results",
  screenOrderResult: "encounter-screen-order-result",
  screenOrderSearchEmpty: "encounter-screen-order-search-empty",
  screenSelectedOrders: "encounter-screen-selected-orders",
  screenSelectedOrderRow: "encounter-screen-selected-order-row",
  screenOrderRemove: "encounter-screen-order-remove",
  screenOrderInstructions: "encounter-screen-order-instructions",
};
